// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__w7cyE","image":"Loader_image__Tz527","rotating":"Loader_rotating__W-D7P"};